// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"b2d8b685","703":"1d9d3a2c","787":"ae585f43"}[chunkId] + ".chunk.js";
};